/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {dismissInAppMessage} from '../api'

export const useMutationDismissInAppMessage = createReactQueryMutationHook('dismissInAppMessage', dismissInAppMessage)
